module.exports = __webpack_public_path__ + "static/img/clock1.50cf52e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/clock1.png
// module id = uLSO
// module chunks = 1